const NS = 'WoolFlystrikeWheelBlock';
const CLS = 'woolFlystrikeWheelBlock';

export class WoolFlystrikeWheelBlock {
    constructor(element) {
        this.element = element;
        this.$element = $(element);
        this.imgOne = this.$element.data('imgone');
        this.imgTwo = this.$element.data('imgtwo');
        this.imgThree = this.$element.data('imgthree');
        this.imgFour = this.$element.data('imgfour');
        this.$canvas = this.$element.find(`#wheelCanvas`)[0];
        this.canvasContext = this.$canvas.getContext('2d');
        this.centerX = this.$canvas.width / 2;
        this.centerY = this.$canvas.height / 2;
        this.layers = [];

        this.resizeCanvas();
        window.addEventListener("resize", () => this.resizeCanvas());
        

        const layerImages = [
            { src: this.imgOne, radius: this.baseSize * 1, angle: 0, rotationStep: 60 },
            { src: this.imgTwo, radius: this.baseSize * 0.84, angle: 0, rotationStep: 72 },
            { src: this.imgThree, radius: this.baseSize * 0.68, angle: 0, rotationStep: 60 },
            { src: this.imgFour, radius: this.baseSize * 0.52, angle: 0, rotationStep: 90 },
        ];

		Promise.all(layerImages.map(layer => this.loadImage(layer.src).then(img => ({ ...layer, img }))))
            .then(loadedLayers => {
                this.layers = loadedLayers;
                this.canvasContext.clearRect(0, 0, this.$canvas.width, this.$canvas.height);
				loadedLayers.forEach(layer => {
					var { img, radius, angle } = layer;
						this.canvasContext.save();
						this.canvasContext.translate(this.centerX, this.centerY);
						this.canvasContext.rotate(angle);
						this.canvasContext.drawImage(img, -radius, -radius, radius * 2, radius * 2);
						this.canvasContext.restore();
				});
            });

        this.$canvas.addEventListener('mousedown', (event) => {
            var { x, y } = this.getMousePos(event);
            var dist = Math.sqrt((x - this.centerX) ** 2 + (y - this.centerY) ** 2);
            var clickedLayer = [...this.layers].reverse().find(layer => dist <= layer.radius);
            if (clickedLayer) {
                console.log(clickedLayer);
                this.animateRotation(clickedLayer, (clickedLayer.rotationStep * Math.PI) / 180); 
            }
        });
    }

    resizeCanvas() {
        let parent = this.$canvas.parentElement;
        let size = Math.min(parent.offsetWidth, 650); 
        this.$canvas.width = size;
        this.$canvas.height = size;
        this.baseSize = size / 2;
        this.centerX = size / 2;
        this.centerY = size / 2;
        this.canvasContext.clearRect(0, 0, this.$canvas.width, this.$canvas.height);
        this.layers.forEach(layer => {
            let { img, radius, angle } = layer;
            if (img) {
                this.canvasContext.save();
                this.canvasContext.translate(this.centerX, this.centerY);
                this.canvasContext.rotate(angle);
                this.canvasContext.drawImage(img, -radius, -radius, radius * 2, radius * 2);
                this.canvasContext.restore();
            }
        });
    }

	animateRotation(layer, targetAngleDelta) {
        let targetAngle = layer.angle + targetAngleDelta;
		let start = performance.now();
        var animate = (current) => {
            var elapsed = current - start;
            var changeAngle = Math.min(elapsed / 650, 1);
            layer.angle = layer.angle + (targetAngle - layer.angle) * changeAngle;

            this.canvasContext.clearRect(0, 0, this.$canvas.width, this.$canvas.height);
			this.layers.forEach(layer => {
				var { img, radius, angle } = layer;
				if (img) {
					this.canvasContext.save();
					this.canvasContext.translate(this.centerX, this.centerY);
					this.canvasContext.rotate(angle);
					this.canvasContext.drawImage(img, -radius, -radius, radius * 2, radius * 2);
					this.canvasContext.restore();
				}
			});

            if (changeAngle < 1) {
                requestAnimationFrame(animate);
            }
        };

        requestAnimationFrame(animate);
    }

    getMousePos(event) {
        var rect = this.$canvas.getBoundingClientRect();
        return {
            x: event.clientX - rect.left,
            y: event.clientY - rect.top
        };
    }

    loadImage(src) {
        return new Promise((resolve, reject) => {
            var img = new Image();
            img.onload = () => resolve(img);
            img.src = src;
        });
    }
}
